import { render, staticRenderFns } from "./HEADLINE.vue?vue&type=template&id=0b939d94&scoped=true&lang=pug"
import script from "./HEADLINE.vue?vue&type=script&lang=js"
export * from "./HEADLINE.vue?vue&type=script&lang=js"
import style0 from "./HEADLINE.vue?vue&type=style&index=0&id=0b939d94&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b939d94",
  null
  
)

export default component.exports